module.exports = __webpack_public_path__ + "static/img/erweima.96a2499.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common-img/erweima.png
// module id = Ej5x
// module chunks = 17